export const APPLICANT_CONTACT_MATCHING_COPY =
  "All details entered are used to match this invite to the applicant's My Applications feed. Please ensure they are correct."
